import { useNavigate } from "react-router-dom";
import { HiXMark } from "react-icons/hi2";
import { useQuery } from "@apollo/client";
import { WRITABLE_REVIEW_ORDERS_BY_USER } from "../../writable-review/page";
import OrderList from "../../order-list";
import { useEffect, useState } from "react";
import LoadingSpinnerFull from "../../../../components/common/loading-spinner/loading-spinner-full";
import { track } from "@amplitude/analytics-browser";
import { postMessage } from "../../../../core/message";

const ReviewComplete = () => {
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(false);
  const { data, loading } = useQuery(WRITABLE_REVIEW_ORDERS_BY_USER, {
    fetchPolicy: "network-only",
  });

  // 주문 리뷰 작성 완료 시 앱(WebView)에서 스토어 인앱 리뷰 요청
  useEffect(() => {
    postMessage("REQ_STORE_REVIEW", {});
  }, []);

  const hasMoreReviews = data && data?.writableReviewOrdersByUser?.length > 0;

  useEffect(() => {
    if (!loading) {
      // 데이터 로딩이 완료된 후 약간의 지연을 두고 애니메이션 시작
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [loading]);

  if (loading) return <LoadingSpinnerFull />;

  return (
    <div className="w-full min-h-screen h-full flex flex-col bg-white">
      <div className="p-4">
        <div
          onClick={() => {
            track("리뷰 작성 완료 페이지 닫기 클릭");
            navigate("/order");
          }}
          className="flex justify-end"
        >
          <HiXMark className="w-8 h-8 text-gray-600" />
        </div>
      </div>

      <div
        className={`flex-1 flex flex-col items-center transition-all duration-700 ease-out transform ${
          isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"
        }`}
      >
        <div className="text-2xl font-bold text-gray-800 mb-6">
          리뷰 작성 완료!
        </div>

        <div className="flex justify-center mb-8">
          <div className="w-20 h-20 bg-primary text-white rounded-full flex items-center justify-center animate-bounce-check">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="checkmark"
            >
              <path className="checkmark-path" d="M20 6L9 17l-5-5" />
            </svg>
          </div>
        </div>

        {hasMoreReviews ? (
          <div className="w-full">
            <div className="flex flex-col items-center mb-4">
              <div className="text-xl font-semibold text-gray-800 mb-2 text-center">
                <p>지금 작성할 수 있는 리뷰가</p>
                <p>{data?.writableReviewOrdersByUser?.length}개 더 있어요!</p>
              </div>
              <div className="text-md text-gray-500">
                바로 이어서 더 작성해볼까요?
              </div>
            </div>

            <div className="w-full flex gap-3 p-4 overflow-x-auto">
              {data?.writableReviewOrdersByUser?.map((order: any) => (
                <OrderList
                  key={order.id}
                  order={[order]}
                  isHorizontal={true}
                  isFromReviewComplete={true}
                />
              ))}
            </div>
          </div>
        ) : (
          <div className="text-center">
            <div className="text-xl font-semibold text-gray-800 mb-2">
              모든 리뷰를 작성했어요 🥰
            </div>
            <div className="text-md text-gray-500">
              다음 주문도 기다리고 있을게요 💌
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ReviewComplete;
